import React, { useState, useMemo } from "react";
import { Box, Divider, List, ListItem, ListItemText, makeStyles, } from "@material-ui/core";
import { Link } from "react-router-dom";
import { FTLDropdownMenuWithController } from "../FTLDropdownMenu";
import { FTLAvatar } from "../FTLAvatar";
import { FTLTypography } from "../FTLTypography";
import { FTLLogoIcon } from "../icons/FTLLogo";
import { typography } from "../../shared/theme";
import { FTLIconButton } from "../FTLIconButton";
export const FTLHeader = ({ profileImageUrl, title, menuIsDisabled = false, profileMenuItems, logoLink = "/", }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const classes = useStyles();
    const profileMenuItemsComponents = useMemo(() => profileMenuItems.map((item) => {
        if ("label" in item)
            return (React.createElement(ListItem, { button: true, disabled: item.isDisabled, className: classes.listItem, onClick: () => {
                    if (item.onClick) {
                        setMenuIsOpen(false);
                        item.onClick();
                    }
                } },
                React.createElement(ListItemText, { className: classes.listItemText }, item.label)));
        return React.createElement(Divider, { className: classes.divider });
    }), [profileMenuItems]);
    return (React.createElement(Box, { component: "header", display: "flex", padding: "16px 28px 16px 24px", maxHeight: 56, alignItems: "center", zIndex: "1305", position: "relative", borderBottom: "1px solid #EBEDF0", style: {
            backgroundColor: "#fff",
        } },
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Link, { to: logoLink, className: classes.link },
                React.createElement(FTLLogoIcon, { sizeRatio: 0.6 }),
                React.createElement(Box, { ml: 4 },
                    React.createElement(FTLTypography, { variant: "h2" }, title)))),
        React.createElement(Box, { ml: "auto" },
            React.createElement(FTLDropdownMenuWithController, { open: menuIsOpen, onClickOutside: () => setMenuIsOpen(false), onClick: () => setMenuIsOpen(true), disabled: menuIsDisabled, placement: "bottom-end", className: classes.listContainer, controller: React.createElement(FTLIconButton, { disableRipple: true, disabled: menuIsDisabled },
                    React.createElement(FTLAvatar, { type: "avatar", src: profileImageUrl, size: "xsmall" })) },
                React.createElement(List, null, profileMenuItemsComponents)))));
};
const useStyles = makeStyles((theme) => ({
    logo: {
        width: "24px",
        height: "24px",
    },
    divider: {
        margin: "4px 0",
    },
    link: {
        display: "flex",
        textDecoration: "none",
    },
    listContainer: {
        minWidth: 192,
        padding: 0,
        margin: "4px 0",
    },
    listItem: {
        padding: "8px 12px",
    },
    listItemText: {
        margin: "0",
        "& > span": Object.assign({}, typography.unsupportedSemanticTags.listItemText),
    },
}));
//# sourceMappingURL=index.js.map